import styled from '@emotion/styled';
import { Text } from '@mantine/core';

export const DropdownContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 240,
  width: '100%',
});

export const DropdownList = styled('div')({
  flex: 1,
  overflowY: 'auto',
  width: '100%',
});

export const DropdownFooter = styled('div')(({ theme }) => ({
  borderTop: `1px solid ${theme.colors.gray[2]}`,
  padding: `0.3em ${theme.spacing.xs}`,
  background:
    theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
}));

export const ItemLabel = styled(Text)<any>(({ theme }) => ({
  fontFamily: theme.fontFamilyMonospace,
  flex: 1,
}));

export const SelectItemStyles = (theme: any) => ({
  item: {
    '&[data-selected]': {
      backgroundColor:
        theme.colorScheme === 'dark'
          ? theme.colors.dark[6]
          : theme.colors.gray[0],
      color:
        theme.colorScheme === 'dark'
          ? theme.colors.gray[0]
          : theme.colors.gray[7],
      '&:hover': {
        backgroundColor:
          theme.colorScheme === 'dark'
            ? theme.colors.dark[6]
            : theme.colors.gray[0],
      },
    },
  },
});
